<template>
    <div class="style-category-outer-container-xs">
        <div class="style-category-empty-container-xs" @click="closeModal"></div>
        <transition
            appear
            enter-active-class="animate__animated animate__slideInUp"
            leave-active-class="animate__animated animate__slideOutDown"
        >
            <div class="style-category-inner-container-xs">
                <div class="position-relative">
                    <p class="fsz-20 primary-color mb-0 fw-bold text-center">Style</p>
                    <div class="style-category-close-btn-xs">
                        <img src="../assets/close-modal-icon.svg" alt="" @click="closeModal" />
                    </div>
                </div>
                <div class="mt-4">
                    <div
                        v-for="(item, index) in styleCategory"
                        :key="index"
                        class="position-relative mb-3"
                        @click="handleSelectStyle(item)"
                    >
                        <div :class="[accentLayerClass(item.id)]"></div>
                        <div class="style-category-image-xs">
                            <img
                                v-lazy="styleCategorySrc(item.src)"
                                alt=""
                                width="100%"
                                height="180px"
                            />
                            <div class="style-category-checkbox-container-xs">
                                <div class="style-category-title-xs">
                                    {{ item.name }}
                                </div>

                                <div :class="[styleCategoryCheckbox(item.id)]"></div>
                            </div>
                        </div>
                        <div
                            v-if="filterSelectedStyles(item).numOfOutput > 0"
                            class="style-category-output-xs"
                        >
                            <span class="fsz-12 white-color fw-medium m-right-1"
                                >No. of Output</span
                            >
                            <span class="border bg-light rounded px-2 m-right-1">
                                <button
                                    :disabled="filterSelectedStyles(item).numOfOutput <= 1"
                                    class="me-2 fw-bold"
                                    role="button"
                                    @click="
                                        decNumOfOutputs(
                                            $event,
                                            filterSelectedStyles(item).id,
                                            index
                                        )
                                    "
                                >
                                    <img src="../assets/minus-icon.svg" alt="" />
                                </button>
                                <span class="me-2 fw-bold fsz-18">{{
                                    filterSelectedStyles(item).numOfOutput > 0
                                        ? filterSelectedStyles(item).numOfOutput
                                        : 0
                                }}</span>
                                <button
                                    class="fw-bold"
                                    role="button"
                                    @click="
                                        incNumOfOutputs(
                                            $event,
                                            filterSelectedStyles(item).id,
                                            index
                                        )
                                    "
                                >
                                    <img src="../assets/plus-icon.svg" alt="" />
                                </button>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
        <div class="style-category-notification-container-xs">
            <transition
                v-if="showNotification"
                enter-active-class="animate__animated animate__slideInLeft"
                leave-active-class="animate__animated animate__slideOutRight"
            >
                <Notification
                    :message="notificationMessage"
                    :status="notificationStatus"
                    @hideNotification="showNotification = false"
                />
            </transition>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Notification from '@/components/snacks/index.vue';

export default {
    components: {
        Notification,
    },
    data() {
        return {
            selectedStyleId: [],
            showNotification: false,
            notificationStatus: '',
            notificationMessage: '',
        };
    },
    computed: {
        ...mapGetters(['styleCategory', 'selectedStyles', 'selectedRoomTypes']),
        styleCategorySrc() {
            return (src) => {
                return `${process.env.VUE_APP_BASE_IMAGE_SRC}${src}`;
            };
        },
    },
    mounted() {
        this.selectedStyles.map((style) => {
            this.selectedStyleId.push(style.id);
        });
    },
    methods: {
        closeModal() {
            this.$emit('close-modal');
        },
        styleCategoryCheckbox(id) {
            if (this.handleFindIndex(id) >= 0) {
                return 'style-category-checkbox-active-xs';
            }
            return 'style-category-checkbox-inactive-xs';
        },
        accentLayerClass(id) {
            if (this.handleFindIndex(id) >= 0) {
                return 'style-category-layer-container-xs';
            }
            return 'opacity-0';
        },
        handleSelectStyle(style) {
            let numOfOutput = 0;
            this.selectedStyles.map((style) => {
                numOfOutput += style.numOfOutput;
            });

            if (this.selectedRoomTypes.length > 0) {
                let payload = {};
                if (this.handleFindIndex(style.id) < 0) {
                    if (numOfOutput > 4) {
                        this.handleNotification(
                            'warning',
                            'We can currently only accept five outputs for each photo'
                        );
                        return;
                    }
                    payload.type = 'add';
                    payload.style = {
                        _id: '',
                        id: style.id,
                        name: style.name,
                        numOfOutput: 1,
                    };

                    this.$store.commit('HANDLE_SELECTED_STYLE', payload);
                    return;
                }
                payload.type = 'remove';
                payload.styleIndex = this.handleFindIndex(style.id);
                this.$store.commit('HANDLE_SELECTED_STYLE', payload);
            } else {
                this.$emit('select-roomType');
                this.showNotification = true;
                this.notificationStatus = 'warning';
                this.notificationMessage = 'Please select a Roomtype first!';
                setTimeout(() => {
                    this.showNotification = true;
                }, 3000);
            }
        },
        decNumOfOutputs(event, id) {
            event.stopPropagation();
            const dispatchData = {
                id,
                type: 'decrease',
            };
            this.$store.commit('handleNumOfOutputs', dispatchData);
            this.$store.commit('setSaveButtonTextVS', 'save-changes');
            this.$store.commit('handleVSChanges', true);
        },
        incNumOfOutputs(event, id, index) {
            event.stopPropagation();

            let numOfOutput = 0;
            const [selectedStyle] = this.selectedStyles.filter((style) => {
                return style.id === id;
            });
            this.selectedStyles.map((style) => {
                numOfOutput += style.numOfOutput;
            });
            if (numOfOutput > 4) {
                this.handleNotification(
                    'warning',
                    'We can currently only accept five outputs for each photo'
                );
                return;
            }
            if (selectedStyle.numOfOutput >= 2) {
                this.showNotification = true;
                this.notificationStatus = 'warning';
                this.notificationMessage =
                    'We can currently only accept two outputs for each style';
                setTimeout(() => {
                    this.showNotification = false;
                }, 3000);
                return;
            }
            const dispatchData = {
                id,
                type: 'increase',
            };
            this.$store.commit('handleNumOfOutputs', dispatchData);
            this.$store.commit('setSaveButtonTextVS', 'save-changes');
            this.$store.commit('handleVSChanges', true);
        },
        filterSelectedStyles(catalogue) {
            const [filteredStyle] = this.selectedStyles.filter((style) => {
                return style.name === catalogue.name;
            });
            if (filteredStyle) {
                return filteredStyle;
            }
            return 0;
        },
        handleFindIndex(id) {
            const styleIndex = this.selectedStyles.findIndex((style) => {
                return style.id === id;
            });
            return styleIndex;
        },
        handleNotification(status, message) {
            this.showNotification = true;
            this.notificationStatus = status;
            this.notificationMessage = message;
            setTimeout(() => {
                this.showNotification = false;
            }, 3500);
        },
    },
};
</script>

<style lang="scss" scoped>
button {
    border: none;
    outline: none;
    background-color: transparent;
}
.style-category {
    &-outer-container-xs {
        position: fixed;
        inset: 0;
        bottom: 0;
        background-color: rgba($color: #888, $alpha: 0.7);
        z-index: 100;
    }
    &-empty-container-xs {
        width: 100%;
        height: calc(100vh - 530px);
    }
    &-inner-container-xs {
        width: 100%;
        height: 530px;
        overflow-y: auto;
        position: absolute;
        bottom: 0;
        border-top-right-radius: 24px;
        border-top-left-radius: 24px;
        padding: 16px;
        background-color: $Background-Color;
    }
    &-close-btn-xs {
        position: absolute;
        top: 0px;
        right: 8px;
    }
    &-layer-container-xs {
        width: 100%;
        height: 180px;
        position: absolute;
        top: 0;
        border-radius: 8px;
        background-color: rgba($color: $Accent-Overlay, $alpha: 0.5);
        z-index: 2;
        transition: background-color 0.7s;
    }
    &-checkbox {
        &-container-xs {
            position: absolute;
            top: 8px;
            right: 0px;
            height: 24px;
            width: 100%;
            display: flex;
            flex-direction: row-reverse;
            padding: 0 8px;
            align-items: center;
        }
        &-input-xs {
            position: absolute;
            width: 24px;
            height: 24px;
            z-index: 5;
            opacity: 0;
            accent-color: $Accent-Color;
        }
        &-active-xs {
            width: 24px;
            height: 24px;
            border-radius: 4px;
            position: absolute;
            top: 0;
            background-image: url('../assets/tick-checkbox.svg');
            background-position: center;
            background-size: contain;
            z-index: 10;
            box-shadow: 0px 4px 5px rgba(24, 36, 133, 0.25);
        }
        &-inactive-xs {
            width: 24px;
            height: 24px;
            position: absolute;
            top: 0;
            background-color: #fff;
            border-radius: 8px;
            z-index: 0;
            box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
        }
    }
    &-image-xs {
        @include centerByFlex;
        img {
            border-radius: 10px;
            position: relative;
            object-fit: cover;
        }
    }
    &-title-xs {
        position: absolute;
        z-index: 6;
        color: #fff;
        font-weight: bold;
        left: 8px;
    }
    &-output-xs {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        position: absolute;
        bottom: 0px;
        z-index: 10;
        width: 100%;
        height: 40px;
        border-radius: 7px;
        background: linear-gradient(360deg, #000000 0%, rgba(0, 0, 0, 0) 100%);
    }

    &-notification {
        &-container-xs {
            width: 330px;
            position: fixed;
            bottom: 20px;
            right: 10px;
            z-index: 200;
        }
    }
}
img[lazy='loading'] {
    width: 48px;
    height: 48px;
}
img[lazy='error'] {
    width: 48px;
    height: 48px;
}
</style>
